export default "__VITE_ASSET__B0vxKbN8__"